import React from 'react';
import Skeleton from 'components/general/Skeleton/Skeleton';

const PageHeaderSkeleton: React.SFC = () => (
  <div className="page-header">
    <Skeleton width={[50, 80]} />
    <Skeleton types={['lg']} width={[200, 250]} />
  </div>
);

export default PageHeaderSkeleton;

